<template>
  <v-menu
    v-model="active"
    :close-on-content-click="false"
    offset-y
    :position-x="0"
    bottom
  >
    <template v-slot:activator="{ on, attrs }">
      <span class="map_link-root">
        <a
          :class="{ 'map_link-active': active }"
          class="map_link"
          color="indigo"
          dark
          v-bind="attrs"
          v-on="on"
          >カメラマップ</a
        >
      </span>
    </template>
    <map-a v-if="!demo" />
    <map-b v-else />
  </v-menu>
</template>

<script>
import { mapState } from 'vuex';
import MapA from './map/MapA.vue';
import MapB from './map/MapB.vue';

export default {
  name: 'Map',
  components: { MapA, MapB },
  data: () => ({
    active: false,
    demo: true,
  }),
  computed: mapState({}),
  methods: {},
};
</script>

<style lang="scss"></style>
